"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixVecBraces = fixVecBraces;
function fixVecBraces(tex) {
    return tex.replace(/\\vec\\textbf{v}/g, "\\vec{\\textbf{v}}");
}
